import {
  ResumeAir,
  ResumeAirRequestQuoteAirFares,
  ResumeAirRequestQuoteAirs
} from 'src/types'
import i18n from 'src/config/i18n'

function quoteAirFaresReduce(
  acc: ResumeAirRequestQuoteAirFares[],
  cur: ResumeAirRequestQuoteAirFares
) {
  if (!cur.family) {
    cur.family = i18n.t('common.uninformed')
  }
  return [...acc, cur]
}

function requestQuoteAirsReduce(
  acc: ResumeAirRequestQuoteAirs[],
  cur: ResumeAirRequestQuoteAirs
) {
  cur.request_quote_air_fares = cur.request_quote_air_fares.reduce(
    quoteAirFaresReduce,
    []
  )
  return [...acc, cur]
}

function resumeAirReduce(acc: ResumeAir[], cur: ResumeAir) {
  cur.request_quote_airs = cur.request_quote_airs.reduce(
    requestQuoteAirsReduce,
    []
  )
  return [...acc, cur]
}

/**
 * @todo
 * this function fix a consolidator failure
 * where it informs the fare family as null
 */
export default function sanitize(resume: ResumeAir[]): ResumeAir[] {
  return resume.reduce(resumeAirReduce, [])
}
